import React from 'react';

import {
  ConstructorGridItemsType,
  ConstructorGridType,
  PossibleConstructorGridItemType,
} from '@/interfaces/constructor.interfaces';
import ConstructorContainer, {
  ConstructorContainerProps,
} from '@/layouts/Constructor/components/ConstructorContainer';
import instanceOfGrid from '@/utils/instanceOfGrid';

const getContainerWithProps = (
  item: PossibleConstructorGridItemType | ConstructorGridType,
) => {
  const ContainerComponent = item.container
    ? (item.Container ?? ConstructorContainer)
    : React.Fragment;

  const containerProps = (item.containerProps || {}) as ConstructorContainerProps;
  const resolveContainerProps = item.container
    ? {
        style: {
          [`--perxis-auto-${item.id}-constructor-container-background-color-inner`]: `var(--perxis-auto-${
            item.id
          }-constructor-container-background-color, ${
            containerProps.style?.backgroundColor ?? 'transparent'
          })`,

          ...containerProps.style,
          backgroundColor: `var(--perxis-auto-${item.id}-constructor-container-background-color-inner)`,
        },
      }
    : {};

  return {
    Container: ContainerComponent,
    props: resolveContainerProps,
  };
};

const prepareConstructorGridItems = (
  items: ConstructorGridItemsType,
): ConstructorGridItemsType => {
  return items.map(item => {
    const isGrid = instanceOfGrid(item);
    const { Container: GridContainer, props: gridContainerProps } =
      getContainerWithProps(item);

    if (!isGrid) {
      return {
        ...item,
        Container: GridContainer,
        containerProps: gridContainerProps,
      };
    }

    return {
      ...item,
      Container: GridContainer,
      containerProps: gridContainerProps,
      items: prepareConstructorGridItems(item.items),
    };
  });
};

const prepareConstructorGrid = (grid: ConstructorGridType): ConstructorGridType => {
  const { Container: GridContainer, props: gridContainerProps } =
    getContainerWithProps(grid);

  return {
    ...grid,
    Container: grid.container ? GridContainer : undefined,
    containerProps: gridContainerProps,
    items: prepareConstructorGridItems(grid.items),
  };
};

export default prepareConstructorGrid;
